import { IRootState } from '@/store';
import { GetterTree } from 'vuex';
import { ILoadingSpinnerState } from './state';

export const getters: GetterTree<ILoadingSpinnerState, IRootState> = {};
